import { render, staticRenderFns } from "./foundFrecastRMB.vue?vue&type=template&id=4a77c655&scoped=true"
import script from "./foundFrecastRMB.vue?vue&type=script&lang=js"
export * from "./foundFrecastRMB.vue?vue&type=script&lang=js"
import style0 from "./foundFrecastRMB.vue?vue&type=style&index=0&id=4a77c655&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a77c655",
  null
  
)

export default component.exports